export const defaultTimeout = 30000;
export const skipPasskeyAppendAfterHybridKey = 'cbo_skip_passkey_append_after_hybrid';
